import '../../assets/styles/AlertBanner.css';

interface AlertBannerProps {
  message: string;
  type?:   'error' | 'warning' | 'success' | 'loading';
}

export default function AlertBanner({ message, type = 'error' }: AlertBannerProps) {
  const getIcon = () => {
    switch (type) {
      case 'success': return <span>✔</span>;
      case 'warning': return <span>⚠</span>;
      case 'loading': return <span className="alert-banner__spinner" aria-hidden="true" />;
      case 'error':
      default:        return <span>✕</span>;
    }
  };

  return (
    <div
      className={`alert-banner alert-banner--${type}`}
      role={type === 'loading' ? 'status' : 'alert'}
      aria-live={type === 'loading' ? 'polite' : 'assertive'}
    >
      <span className="alert-banner__icon" aria-hidden="true">
        {getIcon()}
      </span>
      <span className="alert-banner__message">{message}</span>
    </div>
  );
}
